import {ReactNode} from 'react';

import {MessagePartHandlersFromClient} from '../../core/providers/MessagePartHandlersFromClient';
import {useThreadsMessagePartClient} from '../app/hooks';

export function ThreadsMessagePartHandlers({children}: {children: ReactNode}) {
  const messagePartClient = useThreadsMessagePartClient();

  return (
    <MessagePartHandlersFromClient client={messagePartClient}>
      {children}
    </MessagePartHandlersFromClient>
  );
}
